'use client';

import type React from 'react';
import { createContext, useContext, useRef } from 'react';
import { v4 as uuid } from 'uuid';

const ActivityIdContext = createContext<string | undefined>(undefined);

export const ActivityIdProvider = ({ children }: { children: React.JSX.Element }) => {
  const { current: activityId } = useRef(uuid());

  return <ActivityIdContext.Provider value={activityId}>{children}</ActivityIdContext.Provider>;
};

export const useActivityId = () => {
  const context = useContext(ActivityIdContext);
  if (context === undefined) {
    throw new Error('useActivityId must be used within an ActivityIdProvider');
  }
  return context;
};
